import axios from "axios";
import { API } from "./config";

// Rattache l'abonnement push de CE navigateur à l'utilisateur connecté (le retire des autres comptes côté serveur).
export const rattacherAbonnementPush = async (centreId = null) => {
  try {
    if (!('serviceWorker' in navigator) || !('Notification' in window) || Notification.permission !== 'granted') return;
    const reg = await navigator.serviceWorker.ready;
    const sub = await reg.pushManager.getSubscription();
    if (!sub) return;
    const subscription = sub.toJSON();
    const { data } = await axios.post(`${API}/notifications/refresh-token`, { subscription });
    if (!data?.reregister) return;
    const ua = navigator.userAgent;
    const browser = /Edg\//.test(ua) ? 'Edge' : /Chrome\//.test(ua) ? 'Chrome' : /Firefox\//.test(ua) ? 'Firefox' : /Safari\//.test(ua) ? 'Safari' : 'Inconnu';
    const os = /iPhone|iPad/.test(ua) ? 'iOS' : /Android/.test(ua) ? 'Android' : /Windows/.test(ua) ? 'Windows' : /Mac/.test(ua) ? 'macOS' : 'Inconnu';
    await axios.post(`${API}/notifications/subscribe`, {
      subscription, centre_id: centreId,
      device_info: { userAgent: ua, platform: navigator.platform, deviceName: `${browser} sur ${os}`, browser, os },
    });
  } catch (e) {
    console.log('Rattachement abonnement push ignoré :', e.message);
  }
};
